export default __webpack_public_path__ + "static/media/not_found_image.b747fcbb.png";